/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit, signal} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './library-creative-link-creative-modal.component.html';
import {Uuid} from '../../components/util/uuid';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {CreativeApiService} from '../creative/creative-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

export interface LibraryCreativeLinkCreativeModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-library-creative-link-creative-modal',
  template
})
export class LibraryCreativeLinkCreativeModalComponent implements OnInit {
  model: any;
  onComplete: (result: LibraryCreativeLinkCreativeModalResult) => void;

  name = '';
  destination = true;
  readonly disabled = signal(false);
  readonly validationErrors = signal<any[]>([]);

  private libraryCreative: any;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly creativeApi: CreativeApiService,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.libraryCreative = this.model;
    this.name = this.defaultCreativeName(this.libraryCreative?.name);

  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  createSubmitted(): void {
    if (this.disabled()) {
      return;
    }
    this.disabled.set(true);
    this.validationErrors.set([]);
    this.adnModalLoading.applyModalLoading();

    const creative = {
      id: Uuid.generate(),
      name: this.name,
      libraryCreative: this.libraryCreative
    };

    firstValueFrom(this.creativeApi.savePartial(creative, ['id', 'name', 'libraryCreative'])).then((saved: any) => {
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.({destination: this.destination, creativeId: saved.id});
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled.set(false);
      this.validationErrors.set(_.get(errors, ['data', 'errors'], []));
      this.adnModalLoading.removeModalLoading();
    });
  }

  private defaultCreativeName(creativeName: string): string {
    return 'Creative linked to ' + (creativeName || 'this library creative');
  }
}
